module.exports = __webpack_public_path__ + "static/media/wood_post.7113aceb.jpg";